import { cn } from 'shared/utils/cn';

export const Skeleton = ({ className }: { className?: string }) => (
  <div
    aria-hidden="true"
    className={cn('rounded-md bg-black/[0.07] motion-safe:animate-pulse', className)}
  />
);
